import React from 'react'

import { ThinChevronIcon } from 'components/Utils/Icons'

const BackToSignin = ({ onClick }) => {
  return (
    <div
      className="shade-20 font-size-small font-weight-medium pointer"
      onClick={onClick}
    >
      <div className="flexbox">
        <div
          style={{ transform: 'rotate(180deg)' }}
          className="flexbox flexbox-centered margin-right-small"
        >
          <ThinChevronIcon size={10} />
        </div>
        <div>Back to sign in</div>
      </div>
    </div>
  )
}

export default BackToSignin
